import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '@uigy/shared/components/icons/icon/icon.component';
import { VendorIconComponent } from '@uigy/shared/components/icons/vendor-icon/vendor-icon.component';
import { MatTooltip } from '@angular/material/tooltip';
import { DataChipIcons } from '@uigy/shared/components/data-chip/interface';
import { defaultAssetType, getNameFromType, iconsAssetsByType } from '@uigy/shared/constants/assetTypes.constant';
import { AssetType } from '@uigy/generated/graphql';
import { UiColor } from '@uigy/generated/colors.type';

@Component({
  selector: 'app-data-chip-icon',
  imports: [
    IconComponent,
    VendorIconComponent,
    MatTooltip,

  ],
  templateUrl: './ui-data-chip-icon.component.html',
  styleUrl: './ui-data-chip-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiDataChipIconComponent {
  protected readonly iconsAssetsByType = iconsAssetsByType;

  public icon = input.required<DataChipIcons>();

  public assetTypeTooltip(assetType: AssetType): string {
    return getNameFromType(assetType) ?? defaultAssetType.name;
  }

  public color(): UiColor | 'currentColor' {
    return this.icon().color ?? 'currentColor';
  }

}
